// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Un-z","tupacHeader":"Vn-z","tupacHeader2":"Wn-z","tupacMenu":"Xn-z","tupacMenu2":"Yn-z","tupacMain":"Zn-z","tupacMain2":"_n-z"};